.title {
  width: 180px;
}

.dateSmall {
  width: 100px;
}

.dateLarge {
  width: 125px;
}
